import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class AddDocService {
  dataUrl = Config.URL_BASE;
  pdfUrl = Config.URL_PDF_BUILDER;
  constructor(private http: HttpClient) {
  }
  catalogo(filter: any): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, filter).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postDocsUser(fileToUpload: File, gral_emp_id: number, gral_usr_id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/upload/documentos/' + gral_emp_id + '/' + gral_usr_id;
    url_ = url_.replace(/[?&]$/, '');
    const formData: FormData = new FormData();
    formData.append('zip', fileToUpload, fileToUpload.name);
    return this.http.post(url_, formData).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
}
  cargarCfdisAsociados(ids: number[]): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/get/by/ids';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, ids).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  cargarCfdisAsociadosByPolId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/get/by/pol/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postCtbPolAddDoc(ctb_pol_id: number, add_doc_id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/post/ctb_pol_add_doc/' + ctb_pol_id + '/' + add_doc_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_,{}).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  deleteCtbPolAddDoc(ctb_pol_id: number, add_doc_id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/delete/ctb_pol_add_doc/' + ctb_pol_id + '/' + add_doc_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  putImpto(lista: any[]): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/put/impto';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, lista).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  descargaXml(id: number) {
    let url_ = this.dataUrl + '/add-doc/descarga/documento/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getById(id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getNombreContenidoById(id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/get/content_nombre/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  descargaCfdiPdfZip(dto: any) {
    let url_ = this.pdfUrl + '/pdf/cfdi/generico/zip';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  descargaCfdiPdf(dto: any) {
    let url_ = this.pdfUrl + '/pdf/cfdi/generico/pdf';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  descargaVariosXml(ids: number[]) {
    let url_ = this.dataUrl + '/add-doc/descarga/documentos';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, ids, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
